//============ fixf.core.services.enterprise.ReprotFillQueryPara =============
/* eslint-disable camelcase */
import {QueryParameter} from '@/base/QueryParameter';

export class ReprotFillQueryPara extends QueryParameter {
    constructor() {
        super();
    }

    _QueryAttr_KeyId = 'keyId';
    _QueryAttr_FormluateKeyId = 'formluateKeyId';
    _QueryAttr_CreateDate = 'createDate';
    _QueryAttr_CreatePerson = 'createPerson';
    _QueryAttr_OrgName = 'orgName';
    _QueryAttr_OrgCode = 'orgCode';
    _QueryAttr_Status = 'status';
    _QueryAttr_CommitStatus = 'commitStatus';
    _QueryAttr_Area = 'area';
    _QueryAttr_WorkId = 'workId';


    /*area:String*/
    setParamByArea(area) {
        this.addParameter(this._QueryAttr_Area, area);
    }

    /*workId:String*/
    setParamByWorkId(workId) {
        this.addParameter(this._QueryAttr_WorkId, workId);
    }

    /*status:String*/
    setParamByStatus(status) {
        this.addParameter(this._QueryAttr_Status, status);
    }

    /*keyId:String*/
    setParamByKeyId(keyId) {
        this.addParameter(this._QueryAttr_KeyId, keyId);
    }

    /*statuss:String[]*/
    setParamByStatus_Enum(statuss) {
        this.addParameterByEnum(this._QueryAttr_Status, statuss);
    }

    /*orgCode:String*/
    setParamByOrgCode(orgCode) {
        this.addParameter(this._QueryAttr_OrgCode, orgCode);
    }

    /*orgCodes:String[]*/
    setParamByOrgCode_Enum(orgCodes) {
        this.addParameterByEnum(this._QueryAttr_OrgCode, orgCodes);
    }

    /*startDate:Date, endDate:Date*/
    setParamByCreateDate_Range(startDate, endDate) {
        this.addDateParameterByRange(this._QueryAttr_CreateDate, startDate, endDate);
    }

    /*formluateKeyId:String*/
    setParamByFormluateKeyId(formluateKeyId) {
        this.addParameter(this._QueryAttr_FormluateKeyId, formluateKeyId);
    }

    /*orgName:String*/
    setParamByOrgName(orgName) {
        this.addParameter(this._QueryAttr_OrgName, orgName);
    }

    /*keyIds:String[]*/
    setParamByKeyId_Enum(keyIds) {
        this.addParameterByEnum(this._QueryAttr_KeyId, keyIds);
    }

    /*createDate:Date*/
    setParamByCreateDate(createDate) {
        this.addParameter(this._QueryAttr_CreateDate, createDate);
    }

    /*keyId:String*/
    setParamByKeyIdInEmpty(keyId) {
        this.addParameter(this._QueryAttr_KeyIdInEmpty, keyId);
    }

    /*createPerson:String*/
    setParamByCreatePerson(createPerson) {
        this.addParameter(this._QueryAttr_CreatePerson, createPerson);
    }

    /*createPerson:String*/
    setParamByCreatePersonInEmpty(createPerson) {
        this.addParameter(this._QueryAttr_CreatePersonInEmpty, createPerson);
    }

    /*createPersons:String[]*/
    setParamByCreatePerson_Enum(createPersons) {
        this.addParameterByEnum(this._QueryAttr_CreatePerson, createPersons);
    }

    /*status:String*/
    setParamByStatusInEmpty(status) {
        this.addParameter(this._QueryAttr_StatusInEmpty, status);
    }

    /*formluateKeyId:String*/
    setParamByFormluateKeyIdInEmpty(formluateKeyId) {
        this.addParameter(this._QueryAttr_FormluateKeyIdInEmpty, formluateKeyId);
    }

    /*formluateKeyIds:String[]*/
    setParamByFormluateKeyId_Enum(formluateKeyIds) {
        this.addParameterByEnum(this._QueryAttr_FormluateKeyId, formluateKeyIds);
    }

    /*orgName:String*/
    setParamByOrgNameInEmpty(orgName) {
        this.addParameter(this._QueryAttr_OrgNameInEmpty, orgName);
    }

    /*orgNames:String[]*/
    setParamByOrgName_Enum(orgNames) {
        this.addParameterByEnum(this._QueryAttr_OrgName, orgNames);
    }

    /*orgCode:String*/
    setParamByOrgCodeInEmpty(orgCode) {
        this.addParameter(this._QueryAttr_OrgCodeInEmpty, orgCode);
    }

    /*commitStatus:String*/
    setParamByCommitStatus(commitStatus) {
        this.addParameter(this._QueryAttr_CommitStatus, commitStatus);
    }

    /*commitStatus:String*/
    setParamByCommitStatusInEmpty(commitStatus) {
        this.addParameter(this._QueryAttr_CommitStatusInEmpty, commitStatus);
    }

    /*commitStatuss:String[]*/
    setParamByCommitStatus_Enum(commitStatuss) {
        this.addParameterByEnum(this._QueryAttr_CommitStatus, commitStatuss);
    }

    /*area:String*/
    setParamByAreaInEmpty(area) {
        this.addParameter(this._QueryAttr_AreaInEmpty, area);
    }

    /*areas:String[]*/
    setParamByArea_Enum(areas) {
        this.addParameterByEnum(this._QueryAttr_Area, areas);
    }

    /*workId:String*/
    setParamByWorkIdInEmpty(workId) {
        this.addParameter(this._QueryAttr_WorkIdInEmpty, workId);
    }

    /*workIds:String[]*/
    setParamByWorkId_Enum(workIds) {
        this.addParameterByEnum(this._QueryAttr_WorkId, workIds);
    }

}